import { io } from "socket.io-client";

export const ADMIN_SOCKET_OPTIONS = {
  transports: ["websocket"],
  upgrade: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  randomizationFactor: 0.5,
  timeout: 10000,
};

export const createAdminSocket = (url, options = {}) =>
  io(url, {
    ...ADMIN_SOCKET_OPTIONS,
    ...options,
  });
